export default __webpack_public_path__ + "static/freshms-teaser2-tabletx2-6cb8eb7153ed4b2eb2a73d35e5b6cd0e.png";